import React, { useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import SectionHeader from "../sectionHeader";
import SectionSubHeader from "../sectionSubHeader";
import { ArrowLeft, ArrowRight } from "../../assets/svg";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Slider from "react-slick";
import { Link } from "react-router-dom";

const OurArticle = () => {
  const sliderRefs = useRef({});
  const [activeTab, setActiveTab] = useState("All");

  const blogsArray = [
    {
      image: "/images/idustry-blog-1.png",
      title: "The Future of Staffing: Key Trends Shaping the Industry.",
      link: "https://www.linkedin.com/feed/update/urn:li:activity:7255580492526190592",
      category: "Staffing",
    },
    {
      image: "/images/staffing-1.png",
      title: "Hiring Trends Shaping the IT Industry Today.",
      link: "https://www.linkedin.com/feed/update/urn:li:activity:7259580242363625472",
      category: "Staffing",
    },
    {
      image: "/images/staffing-2.png",
      title: "Where to Begin Your IT Career? Tech Giants vs. Start-ups.",
      link: "https://www.linkedin.com/feed/update/urn:li:activity:7264283737352282114",
      category: "Staffing",
    },
    {
      image: "/images/mentorship-1.png",
      title: "The Power of Mentorship in Workplaces.",
      link: "https://www.linkedin.com/feed/update/urn:li:activity:7268671212216557568",
      category: "Mentorship",
    },
  ];

  const categories = ["All", "Staffing",  "Mentorship"];

  const getFilteredBlogs = (category) => {
    return category === "All"
      ? blogsArray
      : blogsArray.filter((blog) => blog.category === category);
  };

  const getSliderSettings = (blogCount) => ({
    dots: false,
    infinite: blogCount > 1,
    speed: 500,
    slidesToShow: blogCount > 1 ? 2 : 1, // Show 2 if more than 1, else 1
    slidesToScroll: 1,
    arrows: false,
    autoplay: blogCount > 1,
    autoplaySpeed: 2000,
    centerMode: blogCount === 1, // Center when only one card
    centerPadding: blogCount === 1 ? "25%" : "0", // Prevent stretching
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          centerMode: blogCount === 1,
          centerPadding: blogCount === 1 ? "10%" : "0",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: blogCount === 1,
          centerPadding: blogCount === 1 ? "0%" : "0",
        },
      },
    ],
  });
  

  return (
    <div className="volto-section our-articles pb-80">
      <Container>
        <Row>
          <Col lg={7} xs={7}>
            <SectionHeader mainText1="OUR" mainText2="ARTICLES" />
            <SectionSubHeader headerText="Latest Blogs & News" />
          </Col>
          <Col lg={5} xs={5}>
            <div className="custom-arrow">
              <span onClick={() => sliderRefs.current[activeTab]?.slickPrev()}>
                <ArrowLeft />
              </span>
              <span onClick={() => sliderRefs.current[activeTab]?.slickNext()}>
                <ArrowRight />
              </span>
            </div>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <Tabs
              activeKey={activeTab}
              onSelect={(tab) => setActiveTab(tab)}
              className="custom-tabs"
            >
              {categories.map((category) => {
                const filteredBlogs = getFilteredBlogs(category);
                return (
                  <Tab eventKey={category} title={category} key={category}>
                    <Slider
                      {...getSliderSettings(filteredBlogs.length)}
                      className="mt-lg-5 mt-4"
                      ref={(el) => (sliderRefs.current[category] = el)}
                    >
                      {filteredBlogs.map((blog, index) => (
                        <div key={index}>
                          <div className="blogs-card">
                            <img src={blog.image} alt={blog.title} />
                            <h3><Link style={{textDecoration: 'none', color: "unset"}} target="_blank" rel="noreferrer" to={`${blog.link}`}>{blog.title}</Link> </h3>
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </Tab>
                );
              })}
            </Tabs>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default OurArticle;
